import React from "react";
import { useParams } from "react-router-dom";
import { MessageSquareText } from "lucide-react";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";
import InternalChatPanel from "../../components/TicketsManager/InternalChatPanel";

import { i18n } from "../../translate/i18n";
import ContinueWhereLeftOff from "../../components/ContinueWhereLeftOff";

const Chat = () => {
  const { ticketId } = useParams();

  return (
    <div className="flex h-full min-h-0 flex-1 overflow-hidden">
      <div
        className={`h-full w-full shrink-0 overflow-hidden border-r sm:w-[380px] ${
          ticketId ? "hidden sm:block" : "block"
        }`}
      >
        <TicketsManager />
      </div>
      {/* Uma conversa só, nunca duas.
          Antes havia uma cópia para desktop e outra para celular, e com um
          atendimento aberto as DUAS montavam: dois sockets na mesma sala,
          duas buscas do ticket e duas da lista de mensagens a cada abertura.
          Quem decide onde ela aparece é o CSS, não um segundo <Ticket/>.

          min-w-0: item flex nasce com min-width:auto e se recusa a encolher
          além do conteúdo. Sem isso a conversa estica até a largura da maior
          mensagem e vaza para fora da tela — no celular os balões apareciam
          cortados pela direita, com o texto inalcançável. */}
      <div
        className={`min-h-0 min-w-0 flex-1 ${
          ticketId ? "flex" : "hidden sm:flex"
        }`}
      >
        {ticketId ? (
          typeof ticketId === "string" && ticketId.startsWith("internal-") ? (
            <InternalChatPanel chatKey={ticketId} />
          ) : (
            <Ticket />
          )
        ) : (
          <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-4 bg-muted/30 text-center overflow-y-auto">
            <ContinueWhereLeftOff />

            <div className="flex flex-col items-center justify-center gap-3">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                <MessageSquareText className="h-7 w-7" />
              </div>
              <span className="max-w-xs text-sm text-muted-foreground">
                {i18n.t("chat.noTicketMessage")}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
